import React from "react";
import Button from "@Components/Button";
import ColouredBorderBox from "@Components/ColouredBorderBox";
import Form, { InputType } from "@Components/Form";
import Close from "@Components/Icons/Close";
import Loading from "@Components/Icons/Loading";
// import PredictyIconEyesOpen from "@Components/Icons/ChatBot/Predicty/PredictyEyesOpen"
import PredictMascotNewIcon from "@Components/Icons/PredictMascotNew";
import ShieldIcon from "@Components/Icons/ShieldIcon";
import ShieldTickIcon from "@Components/Icons/ShieldTickIcon";
import InfoPopup from "@Components/InfoPopup";
import getBrokerName from "@Helpers/GetBrokerName";
import { validation } from "@Shared/Validate";
import GetPath from "@Helpers/GetPath";
import { LOGIN } from "@Shared/Paths/Auth";
import { NavLink } from "react-router-dom";
import constraints from "./constraints";
import styles from "./index.module.scss";
export default class CreateAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            errors: {},
            companyFound: false,
            companyErrors: [],
            isSearchingCompany: false,
        };
    }
    componentDidUpdate(previousProps, previousState) {
        if (this.state.data.companyNo !== previousState.data.companyNo) {
            this.setState({
                companyFound: false,
                data: {
                    ...this.state.data,
                    company: {},
                    canCreateTender: true,
                },
            });
        }
    }
    inputChange = (data) => {
        this.setState({ data });
    };
    handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            this.submit();
        }
    };
    submit = async () => {
        if (this.state.companyFound) {
            try {
                validation(this.state.data, constraints(this.props.sensabill));
                this.props.create(this.state.data).catch(({ status }) => {
                    if (status === 405) {
                        //need a solution to tell them the email is already in use
                        this.setState({
                            errors: { email: true },
                        });
                    }
                });
            }
            catch (error) {
                this.setState({ errors: error.fails });
            }
            return;
        }
        await this.findCompany();
    };
    findCompany = async () => {
        this.setState({ errors: {}, companyErrors: [] });
        const companyErrors = [];
        const { companyNo } = constraints(this.props.sensabill);
        try {
            validation(this.state.data, {
                companyNo,
            });
        }
        catch (error) {
            for (let index = 0; index < error.fails?.companyNo?.length || 0; index++) {
                companyErrors.push(error.fails.companyNo[index]);
            }
            this.setState({
                errors: { companyNo: true },
                companyErrors,
            });
            return;
        }
        this.setState({ isSearchingCompany: true });
        return this.props
            .findCompany(this.state.data.companyNo)
            .then((companyData) => {
            if (companyData.status === "dissolved") {
                companyErrors.push("This company has been dissolved");
                const data = {
                    ...this.state.data,
                    company: {},
                };
                this.setState({
                    data,
                    companyFound: false,
                    companyErrors,
                    isSearchingCompany: false,
                });
                return;
            }
            const data = {
                ...this.state.data,
                company: { ...companyData },
            };
            this.setState({
                data,
                companyFound: true,
                isSearchingCompany: false,
            });
        })
            .catch(({ error = "" }) => {
            const errorMessage = error.replace(/.*Exception: /, "");
            companyErrors.push(errorMessage);
            const data = {
                ...this.state.data,
                company: {},
            };
            this.setState({
                data,
                companyFound: false,
                companyErrors,
                isSearchingCompany: false,
            });
        });
    };
    getRobotText = (sensabill) => {
        if (sensabill) {
            return (React.createElement(React.Fragment, null, "We do not provide your details to third parties. Information is only used to generate analysis and\u00A0predictions."));
        }
        return (React.createElement(React.Fragment, null, "We do not provide your details to third parties. Information is only shared through the platform to enable the best fit tariff and service\u00A0solution."));
    };
    render() {
        const { data, companyErrors, companyFound, isSearchingCompany } = this.state;
        const { sensabill = false } = this.props;
        const popup = () => {
            return (React.createElement("div", { className: styles.wrapper },
                React.createElement(ColouredBorderBox, { className: styles.noPadding, primary: true, title: React.createElement("div", { className: styles.modalHeader },
                        React.createElement("div", { className: styles.shieldIcon },
                            React.createElement(ShieldIcon, null)),
                        React.createElement("div", { className: styles.header },
                            React.createElement("b", null,
                                "Please create your",
                                " ",
                                React.createElement("span", { className: styles.highlight }, sensabill
                                    ? "Sensabill"
                                    : getBrokerName()),
                                " ",
                                "account"))) },
                    React.createElement("button", { className: styles.closeButton, onClick: this.props.onClose, type: "button", "aria-label": "Close" },
                        React.createElement(Close, { color: "#98A2B3" })),
                    React.createElement("div", { className: styles.container },
                        React.createElement("div", { className: styles.formWrapper },
                            React.createElement("div", { className: styles.form, onKeyDown: this.handleKeyDown },
                                React.createElement(Form, { change: this.inputChange, labelLeft: false, data: this.state.data, errors: this.state.errors, submit: this.submit, buttons: false, rightButton: false, className: styles.formGrid, input: [
                                        {
                                            label: "Name",
                                            name: "name",
                                            className: styles.inputForm,
                                            inputClassName: styles.inputInner,
                                            type: InputType.TextNew,
                                            placeholder: "Enter your name",
                                        },
                                        {
                                            label: "Email",
                                            name: "email",
                                            className: styles.inputForm,
                                            inputClassName: styles.inputInner,
                                            type: InputType.EmailNew,
                                            placeholder: "Enter your email",
                                            customValidation: (value) => {
                                                if (!/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
                                                    return "Please enter a valid email address.";
                                                }
                                            },
                                        },
                                        {
                                            label: "Phone Number",
                                            name: "phoneNumber",
                                            className: styles.inputForm,
                                            inputClassName: styles.inputInner,
                                            type: InputType.TextNew,
                                            placeholder: "Enter your phone",
                                            hidden: sensabill,
                                            customValidation: (value) => {
                                                if (!/^(?:[ \-]?\d){9,15}([ \-])?$/.test(value)) {
                                                    return "Please enter a valid phone number.";
                                                }
                                            },
                                        },
                                        {
                                            label: "Password",
                                            name: "password",
                                            className: styles.inputForm,
                                            inputClassName: styles.inputInner,
                                            type: InputType.PasswordNew,
                                            placeholder: "Create a Password",
                                            showPassword: true,
                                            labelTooltip: "Must be at least 8 characters long and contain at least one special character.",
                                        },
                                        {
                                            label: "Company Number",
                                            name: "companyNo",
                                            className: styles.inputForm,
                                            inputClassName: styles.inputInner,
                                            type: InputType.TextNew,
                                            placeholder: "Enter your company number",
                                        },
                                    ] }))),
                        React.createElement("div", { className: styles.companySection },
                            React.createElement("div", { className: styles.companyTitle },
                                "Your company's details",
                                React.createElement(PredictMascotNewIcon, { className: styles.mascotIcon })),
                            isSearchingCompany && (React.createElement("div", { className: styles.companySearching }, "Searching for your company...")),
                            !isSearchingCompany &&
                                companyErrors.length > 0 && (React.createElement("div", { className: styles.companyDetailsErrors }, companyErrors.join(", "))),
                            !isSearchingCompany &&
                                companyFound &&
                                !!data.company && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: styles.companyDetailsSuccess },
                                    React.createElement("div", { className: styles.companyRow },
                                        React.createElement("span", { className: styles.companyLabel }, "Company name"),
                                        React.createElement("span", { className: styles.companyValue }, data.company.name)),
                                    React.createElement("div", { className: styles.companyRow },
                                        React.createElement("span", { className: styles.companyLabel }, "Company number"),
                                        React.createElement("span", { className: styles.companyValue }, data.company
                                            .companyNo ||
                                            this.state.data
                                                .companyNo)),
                                    React.createElement("div", { className: styles.companyRow },
                                        React.createElement("span", { className: styles.companyLabel }, "Address"),
                                        React.createElement("span", { className: styles.companyValue }, [
                                            data.company
                                                .addressLine1,
                                            data.company.city,
                                            data.company
                                                .postcode,
                                        ]
                                            .filter(Boolean)
                                            .join(", ")))),
                                React.createElement("div", { className: styles.findAgainLink },
                                    "Not your company?",
                                    " ",
                                    React.createElement("button", { type: "button", className: styles.findAgainButton, onClick: () => {
                                            this.setState({
                                                companyFound: false,
                                                companyErrors: [],
                                                data: {
                                                    ...this.state
                                                        .data,
                                                    company: {},
                                                },
                                            });
                                        } }, "Find again"))))),
                        React.createElement("div", { className: styles.privacyNotice },
                            React.createElement("div", { className: styles.shieldIconSmall },
                                React.createElement(ShieldTickIcon, null)),
                            React.createElement("p", { className: styles.privacyText }, this.getRobotText(sensabill))),
                        React.createElement("div", { className: styles.buttonSection },
                            React.createElement(Button, { cta: !isSearchingCompany, click: this.submit, className: `${styles.submitButton} ${isSearchingCompany
                                    ? styles.loadingButton
                                    : ""}`, disabled: isSearchingCompany }, isSearchingCompany ? (React.createElement(Loading, { size: "24px", className: styles.buttonSpinner })) : companyFound ? ("CONFIRM & CREATE") : ("FIND COMPANY")),
                            React.createElement("div", { className: styles.loginLink },
                                React.createElement("span", { className: styles.loginText },
                                    "Already have an account?",
                                    " "),
                                React.createElement(NavLink, { to: GetPath(LOGIN), className: styles.loginButton }, "Log In")))))));
        };
        return (React.createElement(InfoPopup, { trigger: this.props.open === true, content: popup, onClose: this.props.onClose }));
    }
}
